import get from 'lodash/get';

import { TFunction } from '@lyearn/i18n';
import { isFormDataValidFunction } from '@/modules/corporate/modules/database/fields/types';
import { FieldType } from '@/modules/corporate/modules/database/interfaces';

interface Params {
  values: any;
  t: TFunction;
  fields: FieldType[];
}

const defaultIsFormDataValid: isFormDataValidFunction = (data) => Boolean(data);

const validateForm = (params: Params) => {
  const { values, t, fields } = params;
  const errors: any = {};

  fields.forEach((field) => {
    const { required, fieldId, visible } = field.viewField;
    if (!required || !visible) {
      return;
    }

    const { isFormDataValid = defaultIsFormDataValid } = field.config.Viewer;
    if (!isFormDataValid(get(values, fieldId))) {
      errors[fieldId] = t('Database:Required');
    }
  });

  return errors;
};

export default validateForm;
